import { axiosInstance } from "..";

export const getBlogCategories = async ({ type = "isBlog" }) => {
  return new Promise((resolve, reject) => {
    axiosInstance
      .get("/categories")
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.categories
            ?.filter((n) => n?.[type])
            .map((item) => {
              return {
                label: item?.name ? item?.name : item?.name,
                isLang: true,
                value: item?._id,
              };
            });
          resolve({
            success: true,
            data: data?.length ? data : [],
            message: res?.message,
          });
        } else {
          reject({ success: false, data: [], message: res?.message });
        }
      })
      .catch((err) => {
        reject({ success: false, data: [], message: err?.message });
      });
  });
};

export const getBlogAll = async ({ filters, page, limit }) => {
  return new Promise((resolve, reject) => {
    var params = {
      pageNo: page,
    };
    if (limit) {
      params.pageSize = limit;
    }
    if (filters?.categories?.length) {
      params.categories = filters?.categories?.join(",");
    }
    if (filters?.search) {
      params.search = filters?.search;
    }
    if (filters?.featured) {
      params.featured = filters?.featured;
    }
    axiosInstance
      .get("/blogs", { params })
      .then((res) => {
        if (res?.code === 200) {
          let data = res?.data?.blogs
            ?.filter((n) => n)
            .map((item, index) => {
              return {
                slug: item?.slug,
                index: index,
                coverImage: item?.coverImage || "",
                title: item?.title ? item?.title : "",
                tag: "",
                authors: [item?.author],
                shortDescription: item?.shortDescription || "",
              };
            });
          resolve({
            success: true,
            data: {
              list: data,
              total: res?.meta?.total ? res?.meta?.total : 0,
            },
            message: res?.message,
          });
        } else {
          reject({
            success: false,
            data: { list: [], total: 0 },
            message: res?.message,
          });
        }
      })
      .catch((err) => {
        reject({
          success: false,
          data: { list: [], total: 0 },
          message: err?.message,
        });
      });
  });
};
